// Single source of truth for Acodia Watch plan display copy.
//
// Both the marketing page (AcodiaWatchPage) and the in-dashboard upgrade picker
// (DashboardPage) derive their plan cards from this object. Update plan names,
// prices, descriptions, or feature bullets HERE and both surfaces stay in sync.
//
// NOTE: this is frontend *display* copy only. The Stripe price/plan resolution
// (backend stripe_service PRICE_MAP) is the separate billing source of truth and
// must not be driven from this file.

export const PLANS = {
  essential: {
    name: 'Essential',
    price: { monthly: 49, annual: 490 },
    description: 'For startups & solo founders monitoring a single domain.',
    valueProp: 'For solo founders who need continuous protection, not just scans',
    features: [
      '1 domain monitored',
      'Daily scans',
      'Critical email alerts',
      'Monthly AI security briefing',
      '7-day scan history',
      'Email support',
    ],
    cta: 'Choose Essential',
  },
  professional: {
    name: 'Professional',
    price: { monthly: 99, annual: 990 },
    description: 'For growing businesses managing multiple sites.',
    valueProp: 'For growing businesses that need evidence, alerts, and confidence',
    features: [
      'Up to 5 domains monitored',
      'Hourly continuous scans',
      'Real-time email + Slack alerts',
      'Weekly AI security briefings',
      '90-day scan history',
      'SSL/TLS monitoring',
      'PDF compliance reports',
      'Priority email support',
    ],
    cta: 'Choose Professional',
    mostPopular: true,
  },
  business: {
    name: 'Business',
    price: { monthly: 199, annual: 1990 },
    description: 'For agencies and established businesses with compliance needs.',
    valueProp: 'For established businesses where security needs to be auditable and defensible',
    features: [
      'Up to 10 domains monitored',
      'Real-time scanning',
      'Multi-channel alerts (email, Slack, Teams, webhook)',
      'On-demand AI briefings',
      'Unlimited scan history',
      'Compliance reports (Cyber Essentials, ISO 27001)',
      'White-labelled PDF reports',
      'Dedicated account manager',
      'Priority phone + email support',
    ],
    cta: 'Choose Business',
  },
};
